module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dialogTitle":"Edit event","eventsActionsEditOneSuccess":"%{eventsTitle} was successfully updated in the database"},"no":{"dialogTitle":"Rediger stevne","eventsActionsEditOneSuccess":"%{eventsTitle} ble redigert i databasen"}}')
  delete Component.options._Ctor
}
